import React from "react";
import styled from "styled-components";

import ConfirmationModal from "components/digital_gift_cards/confirmation_modal";
import Footer from "components/digital_gift_cards/footer";
import Header from "components/digital_gift_cards/header";
import MainContent from "components/digital_gift_cards/main_content";
import { calculateLeftMargin } from "helpers/digital_gift_cards";
import useViewportDimensions from "helpers/hooks/useViewportDimensions";
import type {
  DigitalGiftCardOrderApiResponse,
  DigitalGiftCardsSettings,
  Flags,
  SubmitGiftCardCreditCardPaymentProps,
} from "types/digital_gift_cards";

import { type RemoteData, RequestStatus } from "types/requests";

export const StyledDGCPurchasePage = styled.div`
  background: #ffffff;
  margin: 0;

  font-family: "Graphik", sans-serif;
  font-style: normal;
  font-weight: normal;
  color: #000000;

  min-height: 100vh;
`;

type PurchasePageProps = {
  settings: DigitalGiftCardsSettings;
  afterProcessedPaymentRequest: RemoteData<DigitalGiftCardOrderApiResponse>;
  creditCardRequestStatus: RequestStatus;
  onSubmitCreditCardPayment: (
    props: SubmitGiftCardCreditCardPaymentProps
  ) => void;
  onSetCreditCardRequestStatus: (props: RequestStatus) => void;
  flags: Flags;
};

export default function PurchasePage({
  settings,
  afterProcessedPaymentRequest,
  creditCardRequestStatus,
  onSetCreditCardRequestStatus,
  onSubmitCreditCardPayment,
  flags,
}: PurchasePageProps) {
  const { w } = useViewportDimensions();

  const closeModalClick = () => {
    window.location.reload();
  };

  return (
    <StyledDGCPurchasePage>
      <Header
        settings={settings}
        leftMargin={calculateLeftMargin(w)}
        flags={flags}
      />
      <MainContent
        settings={settings}
        leftMargin={calculateLeftMargin(w)}
        afterProcessedPaymentRequest={afterProcessedPaymentRequest}
        creditCardRequestStatus={creditCardRequestStatus}
        onSubmitCreditCardPayment={onSubmitCreditCardPayment}
        onSetCreditCardRequestStatus={onSetCreditCardRequestStatus}
      />
      <Footer />
      {RequestStatus.SUCCESS === afterProcessedPaymentRequest.type && (
        <ConfirmationModal
          orderResponse={afterProcessedPaymentRequest.result}
          ccLastFour={afterProcessedPaymentRequest.result.lastFour!}
          closeModalClick={closeModalClick}
        />
      )}
    </StyledDGCPurchasePage>
  );
}
